/*
 * Copyright (c) 2026. Tooling Team
 */

import HeaderService from "../services/headerService";
import { useSelector, useDispatch } from "react-redux";
import { useGetAllMedDomainEISBuildsQuery } from "../app/services/medDomainEISApi";
import { useEffect } from "react";
import { setMedDomainEISBuildRowData } from "../app/slices/medDomainEIS.slice";

export default () => {
  const { medDomainEISBuildRowData } = useSelector(
    (state) => state.medDomainEIS
  );

  const dispatch = useDispatch();
  const { data: buildsData } = useGetAllMedDomainEISBuildsQuery();
  const headerService = new HeaderService();

  useEffect(() => {
    if (Array.isArray(buildsData) && buildsData.length > 0) {
      dispatch(setMedDomainEISBuildRowData(buildsData));
    }
  }, [buildsData, dispatch]);

  return {
    state: {
      medDomainBuildRowData: medDomainEISBuildRowData,
    },
    headerService,
  };
};
